import { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import SiteLayout from "./components/layout/SiteLayout";
import { pages, paletteFor, profile, projects, themeColor } from "./data/site";
import ProductPage from "./pages/ProductPage";
import AboutPage from "./pages/AboutPage";
import BusinessPage from "./pages/BusinessPage";
import ChessPage from "./pages/ChessPage";
import CineMovie from "./components/CineMovie";
import ContactPage from "./pages/ContactPage";
import HomePage from "./pages/HomePage";
import NotFoundPage from "./pages/NotFoundPage";
import ProjectsPage from "./pages/ProjectsPage";
import TechnologyPage from "./pages/TechnologyPage";

function AppFrame() {
  const location = useLocation();
  const pathname = location.pathname.replace(/\/$/, "") || "/";
  const isCinema = pathname === "/cinemovie";
  const product = projects.find((item) => item.landing && item.href === pathname);
  const palette = paletteFor(product);
  const page = pages[pathname] || { theme: "light", title: "Page not found" };

  document.documentElement.dataset.theme = isCinema ? "cinema" : product?.theme || page.theme;
  if (palette?.bg) document.documentElement.style.setProperty("--bg", palette.bg);
  else document.documentElement.style.removeProperty("--bg");

  useEffect(() => {
    if (location.hash) {
      const target = document.querySelector(location.hash);
      if (target) {
        target.scrollIntoView();
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [location.pathname, location.hash]);

  useEffect(() => {
    document.title = page.title === profile.name ? page.title : `${page.title} — ${profile.name}`;
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute("content", palette?.bg || themeColor[page.theme] || themeColor.light);
  }, [page.title, page.theme, palette]);

  if (isCinema) {
    return <CineMovie />;
  }

  if (product) {
    return <ProductPage project={product} />;
  }

  return (
    <SiteLayout>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/technology" element={<TechnologyPage />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/chess" element={<ChessPage />} />
        <Route path="/business" element={<BusinessPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </SiteLayout>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppFrame />
    </BrowserRouter>
  );
}
